import { FormFilter } from "../models/FormFilter";

export function filterValuesAreValid(filter: FormFilter): boolean {
    if (!validateSSN(filter.ssn)) {
        return false;
    }

    if (!validateName(filter.name)) {
        return false;
    }
    return true;
}

export function isValidFilterForm(filter: FormFilter) {
    return filterValuesAreValid(filter) && containsAFilter(filter);
}

export function containsAFilter(filter: FormFilter): boolean {
    if (filter.ssn && filter.ssn !== "") {
        return true;
    }

    if (filter.name && filter.name !== "") {
        return true;
    }

    if (filter.documentId && filter.documentId !== "") {
        return true;
    }

    if (filter.period) {
        return true;
    }

    if (!!filter.errorTypes.length) {
        return true;
    }

    if (!!filter.statusTypes.length) {
        return true;
    }

    if (!!filter.municipalities.length) {
        return true;
    }

    if (filter.onlyFormsWithError) {
        return true;
    }

    return false;
}

export function validateSSN(ssn: string) {
    if (ssn?.trim() === "") {
        return true;
    }

    var expression = "^[0-9]{6}-[0-9]{4}$";
    var reg = new RegExp(expression);

    return reg.test(ssn);
}

export function validateName(name: string) {
    if (name?.trim() === "" && name !== "") {
        return false;
    }

    return true;
}
